/*
 * @Author: liujunhong
 * @Date: 2022-12-08
 * @Desc:
 */

const files = require.context('./models', false, /\.js$/)
const models = {}
files.keys().forEach(key => {
  const filename = key.replace(/(\.\/|\.js)/g, '')
  models[filename] = files(key).default
})
console.log(models)
export default models